import React from 'react';
import { Typography } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import DismissibleAlert from '../../../components/DismissibleAlert';

const { Text, Paragraph } = Typography;

export const ORGS_DIRECTORY_GUIDE_BANNER_KEY = 'orgs-directory-guide-v1';

/**
 * Colored in-product guide for the organizations directory.
 */
export default function OrganizationsDirectoryGuide() {
  return (
    <DismissibleAlert
      bannerKey={ORGS_DIRECTORY_GUIDE_BANNER_KEY}
      type="error"
      banner
      showIcon
      icon={<WarningFilled />}
      className="organizations-directory-guide-alert"
      style={{
        marginBottom: 16,
        borderRadius: 8,
        border: '1px solid #ffa39e',
        background: 'linear-gradient(90deg, #fff1f0 0%, #fff7f6 100%)',
        padding: '12px 16px',
      }}
      message={(
        <Text strong style={{ color: '#a8071a', fontSize: 14 }}>
          How to manage an organization
        </Text>
      )}
      description={(
        <div className="organizations-directory-guide" style={{ color: '#820014' }}>
          <Paragraph style={{ marginBottom: 4, color: 'inherit' }}>
            <Text strong style={{ color: 'inherit' }}>Start from a company</Text>
          </Paragraph>
          <ul style={{ margin: 0, paddingLeft: 18, color: 'inherit' }}>
            <li>
              Open an organization to edit profile, manage plans, renew coverage, and review
              members / staff uploads / plan requests for <Text strong style={{ color: 'inherit' }}>that</Text> company
            </li>
            <li>
              Use the <Text strong style={{ color: 'inherit' }}>Staff uploads</Text>
              {' '}header button for the cross-company upload queue
            </li>
            <li>
              If an upload is partially applied with remaining conflicts, use the company banner
              to open holds for that session, or the <Text strong style={{ color: 'inherit' }}>Enrollment holds</Text>
              {' '}header button
            </li>
            <li>
              Badges on <Text strong style={{ color: 'inherit' }}>Staff uploads</Text>
              {' '}or <Text strong style={{ color: 'inherit' }}>Enrollment holds</Text>
              {' '}mean work is waiting — you can dismiss this tip anytime with the close button
            </li>
            <li>
              <Text strong style={{ color: 'inherit' }}>Add organization</Text>
              {' '}creates a new corporate account here
            </li>
          </ul>
        </div>
      )}
    />
  );
}
